import { Box, Button, CircularProgress, IconButton, Skeleton, Snackbar, useMediaQuery } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import React, { createRef, useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import TextArea from 'antd/es/input/TextArea';
import { io } from 'socket.io-client';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MicIcon from '@mui/icons-material/Mic';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import {motion} from "framer-motion"
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import EachMessaages from './EachMessages';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import CloseIcon from '@mui/icons-material/Close';


const socket = io(process.env.REACT_APP_URL);

export default function Each_chat({handleLatestMessage,latestMessage,userData,ActiveShope,handle_optimizer,optimizer,notification, setNotification,handleOnline,online,unread}) {
 
//let inputRef=createRef()  
const [anchorEl, setAnchorEl] = React.useState(null);
const open = Boolean(anchorEl);
let [toTop,gotoTOp]=useState(false)
const location = useLocation()
const [routes,setRoutes]=useState(location.pathname.split("/"))
 
 let [content,handle_content]=useState("")
 const [socketConnected, setSocketConnected] = useState(false);
 const [typing, setTyping] = useState(false);
 const [istyping, setIsTyping] = useState(false);

  //////////editing message
let[replayinggMessageContent,setReplayinggMessageContent]=useState({})

  useEffect(()=>{
    if(toTop) {gotoTOp(false)}
   // // console.log(toTop);
  },[location])

  
  //goto lastmessaage
  let [AllChats,GetAllChats]=useState([])

const containerRef = useRef(null);
useEffect(() => {
  if(containerRef && containerRef.current) {
    const element = containerRef.current;
    element.scroll({
      top:toTop?0:element.scrollHeight,
      left: 0,
      behavior: "smooth"
    })
  }
}, [containerRef,routes[0],AllChats])

  useEffect(() => {
    let newRoute=location.pathname.split("/")
    setRoutes(newRoute);
  }, [location.pathname]);


  useEffect(()=>{
    axios.get(`${process.env.REACT_APP_URL}/api/messages/GetAllChatmessage/${routes[2]}?ActiveShope=${ActiveShope}`, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      GetAllChats(res.data)
      socket.emit("join chat", routes[2]);
    })
    .catch(error=>{
     // // console.log(error);
    })

  },[optimizer,routes])

  let shope=userData?.shopes?.filter(e=>{
    return e?._id.toString()===ActiveShope
  })[0]

  let [selected_chat,handle_selected_chat]=useState()
  let [selected_chat_error,handle_selected_chat_error]=useState(false)
  let [selected_chat_load,handle_selected_chat_load]=useState(false)
  let [selected_chat_shop,handle_selected_chat_shop]=useState({})

  useEffect(()=>{
    handle_selected_chat_load(true)
    axios.get(`${process.env.REACT_APP_URL}/api/chats/EachChat/${routes[2]}`, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      handle_selected_chat(res.data)
      handle_selected_chat_error(false)
      handle_selected_chat_load(false)
    })
    .catch(error=>{
     console.log(error);
      handle_selected_chat_error(true)
      handle_selected_chat_load(false)
      setTimeout(()=>{
        window.location.href = "/chat";
      },1000)
    })
  },[location.pathname,ActiveShope])

  useEffect(()=>{
   let selected_shop=selected_chat?.shops?.filter(e=>{
     return e?._id?.toString()!==ActiveShope
   })
   if(selected_shop&&selected_shop.length>0){
     handle_selected_chat_shop(selected_shop[0])
   }
   else{
    handle_selected_chat_shop({})
   }
  },[selected_chat])

 // // console.log(selected_chat,selected_chat_shop);
  useEffect(()=>{
  
        handleOnline({
                 ...online,
                istyping:istyping,
                chat: routes[2]
              });

  },[istyping])

  //onsole.log(shope);
  useEffect(() => {

        socket.emit("setup", shope);
        socket.on("connected", () => setSocketConnected(true));
        socket.on("typing", () => setIsTyping(true));
        socket.on("stop typing", () => setIsTyping(false));

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    socket.on("message recieved", (newMessageRecieved) => {
       //handle_optimizer(optimizer+2)
       unread.handleControlUnread(unread.controlUnread+2)
        
      let latestMessageForThatChat=latestMessage.filter(e=>{
        return e?.chat?._id===newMessageRecieved?.chat?._id
     })

     if(latestMessageForThatChat.length>0){
        handleLatestMessage(element=>element.map(e=>{
          return e?.chat?._id===newMessageRecieved?.chat?._id?{
                        ...e,
                        sender:newMessageRecieved?.sender,
                        content:newMessageRecieved?.content,
                        image:newMessageRecieved?.image,
                        audio:newMessageRecieved?.audio,
                        deletedFrom:newMessageRecieved?.deletedFrom,
                        _id:newMessageRecieved?._id,
                      }:{...e}
          }))
      }
      else{
        handleLatestMessage(e=>[...e,newMessageRecieved])
      }
      if (
        !routes[2] || // if chat is not selected or doesn't match current chat
        routes[2] !== newMessageRecieved.chat._id.toString()
      ) {
      
        if (!notification.has(newMessageRecieved.chat.createdAt)) {
       //   // console.log(newMessageRecieved.chat);
          setNotification(prevNotification => new Set([...prevNotification, newMessageRecieved.chat.createdAt]));
          
        }
      } else {
        GetAllChats([...AllChats, newMessageRecieved]);
      }
    });
  });

  let [error_send,handle_error_send]=useState(false)
  let [load_send,handle_load_send]=useState(false)

  const Send_Message=()=>{
    handle_load_send(true)
    socket.emit("stop typing", routes[2]);
    let data={
    content:content,
    chatId:routes[2],
    sender:ActiveShope,
    isLoading:true,
    }  
    if(replayinggMessageContent?._id){
      data["repliedFor"]=replayinggMessageContent?._id
    }
   //console.log(data);
    axios.post(`${process.env.REACT_APP_URL}/api/messages/CreatMessage`,data, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      handle_error_send(false)
     // handle_optimizer(optimizer+2)
      handle_content("")
      // console.log(res.data);
      
      let latestMessageForThatChat=latestMessage.filter(e=>{
        return e?.chat?._id===res.data?.chat?._id
     })

     if(latestMessageForThatChat.length>0){
        handleLatestMessage(element=>element.map(e=>{
          return e?.chat?._id===res.data?.chat?._id?{
                        ...e,
                        sender:res.data?.sender,
                        content:res.data?.content,
                        image:res.data?.image,
                        audio:res.data?.audio,
                        deletedFrom:res.data?.deletedFrom,
                        _id:res.data?._id,
                      }:{...e}
          }))
      }
      else{
        handleLatestMessage(e=>[...e,res.data])
      }
      
     unread.handleControlUnread(unread.controlUnread+2)
      handle_load_send(false)
      GetAllChats([...AllChats, res.data]);
      setReplayinggMessageContent({})
      socket.emit("new message", res.data)
    })
    .catch(error=>{
     handle_load_send(false)
     GetAllChats([...AllChats, data]);
     handle_content("")
     // handle_error_send(true)
      //setTimeout(()=>{
        //handle_error_send(false)
      //},3000)
    })
  }


  const typingHandler = (e) => {
    handle_content(e.target.value);

    if (!socketConnected) return;

    if (!typing) {
      setTyping(true);
      socket.emit("typing", routes[2]);
    }
    let lastTypingTime = new Date().getTime();
    var timerLength = 20000;
    setTimeout(() => {
      var timeNow = new Date().getTime();
      var timeDiff = timeNow - lastTypingTime;
      if (timeDiff >= timerLength && typing) {
        socket.emit("stop typing", routes[2]);
        setTyping(false);
      }
    }, timerLength);
  };

  const matches = useMediaQuery('(max-width:600px)');
  let navigate=useNavigate()
  const handleBackToAllChats=()=>{
    navigate("/chat")
  }

const handleKeyDown = (event) => {
    if (event.key === 'Enter'&&(content&&content.length>0)) {
      event.preventDefault(); // Prevent the default behavior of newline insertion
      Send_Message(); // 
    }
  };


//////audio
  const [stream, setStream] = useState(null);
  const mediaRecorder = useRef(null);
  const [recordingStatus, setRecordingStatus] = useState("inactive");
  const [audioChunks, setAudioChunks] = useState([]);
  const [audio, setAudio] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [duration, setDuration] = useState(0);

 
 const startRecording = async () => {

     if ("MediaRecorder" in window) {
          try {
            const streamData = await navigator.mediaDevices.getUserMedia({
              audio: true,
            });
            setStream(streamData);
            setRecordingStatus("recording");
            setStartTime(new Date());
           // const streamData = await navigator.mediaDevices.getUserMedia({
             // audio: true,
            //});
            ///setStream(streamData);
            const mimeType = "audio/webm";
            const media = new MediaRecorder(streamData, { type: mimeType });
            mediaRecorder.current = media;
            const localAudioChunks = [];
        
            mediaRecorder.current.ondataavailable = (event) => {
              if (typeof event.data === "undefined") return;
              if (event.data.size === 0) return;
              localAudioChunks.push(event.data);
            };
        
            mediaRecorder.current.start();
            setAudioChunks(localAudioChunks);


          } catch (err) {
            alert(err.message);
          }
        } else {
          alert("The MediaRecorder API is not supported in your browser.");
        }
   
  };

  const stopRecording = async () => {
    setRecordingStatus("inactive");
    setEndTime(new Date());
    mediaRecorder.current.stop();
    stream.getTracks().forEach((track) => track.stop());
  };

  useEffect(() => {
      let intervalId;
  
      if (recordingStatus === "recording") {
        intervalId = setInterval(() => {
          const currentTime = new Date().getTime();
          setDuration(currentTime - startTime);
        }, 100);
      } else {
        clearInterval(intervalId);
      }
  
      return () => {
        clearInterval(intervalId);
      };
    }, [recordingStatus, startTime]);
  
    const formatTime = (time) => {
      const minutes = Math.floor(time / 60000);
      const seconds = Math.floor((time / 1000) % 60);
  
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    //// console.log(audio);

  const sendAudioFile = async () => {
      handle_load_send(true)
      setRecordingStatus("inactive");
      setEndTime(new Date());
      mediaRecorder.current.stop();
      mediaRecorder.current.onstop = async () => {
        let audioBlob = new Blob(audioChunks, { type: "audio/mpeg" });
        const audioUrl = URL.createObjectURL(audioBlob);
        audioBlob = await fetch(audioUrl).then((response) => response.blob());
       // const convertedAudioBlob = await convertToMP3(audioBlob);

        const file = new File([audioBlob], "recording.mpeg", { type: audioBlob.type });
        
        //formData.append("resource_type", "auto");
        //formData.append("isLoading", true);
        
        setAudio(audioUrl);
        socket.emit("stop typing", routes[2]);
       
        let data={
          content:'audio',
          chatId:routes[2],
          sender:ActiveShope,
          isLoading:true,
          } 
          const formData = new FormData();
          formData.append("file", file);
          formData.append("chatId", routes[2]);
          formData.append("sender", ActiveShope);
          formData.append("resource_type", "auto");
          // console.log(file,formData);
          if(replayinggMessageContent?._id){
            formData.append("repliedFor", replayinggMessageContent?._id);
          }
      axios.post(`${process.env.REACT_APP_URL}/api/messages/CreatMessage`,formData, //proxy uri
          {
             headers: {
                authorization:`Bearer ${ userData?.token }`,
                'Content-Type': 'multipart/form-data',
             } 
          })
        .then(res=>{
          handle_error_send(false)
         // handle_optimizer(optimizer+2)
          handle_content("")
          // console.log(res.data);
          setReplayinggMessageContent({})

          let latestMessageForThatChat=latestMessage.filter(e=>{
            return e?.chat?._id===res.data?.chat?._id
         })
    
         if(latestMessageForThatChat.length>0){
            handleLatestMessage(element=>element.map(e=>{
              return e?.chat?._id===res.data?.chat?._id?{
                            ...e,
                            sender:res.data?.sender,
                            content:res.data?.content,
                            image:res.data?.image,
                            audio:res.data?.audio,
                            deletedFrom:res.data?.deletedFrom,
                            _id:res.data?._id,
                          }:{...e}
              }))
          }
          else{
            handleLatestMessage(e=>[...e,res.data])
          }

         unread.handleControlUnread(unread.controlUnread+2)
         handle_load_send(false)
          GetAllChats([...AllChats, res.data]);
          socket.emit("new message", res.data)
        })
        .catch(error=>{
          handle_load_send(false)
         // console.log(error);
         GetAllChats([...AllChats, data]);
         handle_content("")
         // handle_error_send(true)
          //setTimeout(()=>{
            //handle_error_send(false)
          //},3000)
        })
        setAudioChunks([]);
      };
      stream.getTracks().forEach((track) => track.stop());
  
 } 

  
 ///send image
 let [imageOptioned,setImageOptioned]=useState(false)
 let[image,getImage]=useState(null)
 let [loading,setLoading]=useState(false)
 let [errorImage,setErrorImage]=useState(false)
 const [selectedFile, setSelectedFile] = useState(null);

 const handleImageChange=(event)=>{
  getImage("")
  setImageOptioned(true)
  let file=event.target.files[0]
  // console.log(file);
  setSelectedFile(file);
  if (file?.size > 1 * 1024 * 1024) {
      setErrorImage('File size should not exceed 1MB');
      return;
    }
  if(file?.type?.startsWith('image')){
    getImage(file)
      setErrorImage(false)
  }
  else{
      setErrorImage("Please use valid image")
  }
  
}

const cancelImage=()=>{
  setSelectedFile(null) 
  getImage("")
  setImageOptioned(false)
}

const sendImage=()=>{
  handle_load_send(true)
  handle_content("")
  setSelectedFile(null) 
  getImage("")
  const formData = new FormData();
  formData.append("file", image);
  formData.append("chatId", routes[2]);
  formData.append("sender", ActiveShope);
  //formData.append("isLoading", true);
  if(replayinggMessageContent?._id){
    formData.append("repliedFor", replayinggMessageContent?._id);
  }
  //// console.log(image);
  socket.emit("stop typing", routes[2]);
 
  let data={
    content:'image',
    chatId:routes[2],
    sender:ActiveShope,
    isLoading:true,
    } 

  axios.post(`${process.env.REACT_APP_URL}/api/messages/CreatMessage`,formData, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ userData?.token }`,
        'Content-Type': 'multipart/form-data',
     } 
  })
  .then(res=>{
    handle_error_send(false)
   // handle_optimizer(optimizer+2)
 
    setImageOptioned(false)
    // console.log(res.data);

    let latestMessageForThatChat=latestMessage.filter(e=>{
      return e?.chat?._id===res.data?.chat?._id
   })

   if(latestMessageForThatChat.length>0){
      handleLatestMessage(element=>element.map(e=>{
        return e?.chat?._id===res.data?.chat?._id?{
                      ...e,
                      sender:res.data?.sender,
                      content:res.data?.content,
                      image:res.data?.image,
                      audio:res.data?.audio,
                      deletedFrom:res.data?.deletedFrom,
                      _id:res.data?._id,
                    }:{...e}
        }))
    }
    else{
      handleLatestMessage(e=>[...e,res.data])
    }

    setReplayinggMessageContent({})
   unread.handleControlUnread(unread.controlUnread+2)
     handle_load_send(false)
    GetAllChats([...AllChats, res.data]);
    socket.emit("new message", res.data)
  })
  .catch(error=>{
   handle_load_send(false)
   // console.log(error);
   GetAllChats([...AllChats, data]);
   handle_content("")
   // handle_error_send(true)
    //setTimeout(()=>{
      //handle_error_send(false)
    //},3000)
  })
};


//// console.log(selectedFile,imageOptioned);

////emoji
const myref = useRef();
const [emoji, setEmoji] = useState(false);

const handleEmojiClick = () => {
  setEmoji(!emoji);
  const bodyInput = myref.current;
  bodyInput.focus();
  bodyInput.selectionStart = bodyInput.value.length;
};

useEffect(() => {
  if (!myref.current) return;
  const bodyInput = myref.current;
  bodyInput.focus();
  bodyInput.selectionStart = bodyInput.value.length; // Set cursor to the end of text on initial render
}, [myref]);


const handleEmojiSelect = (emoji) => {
  const bodyInput = myref.current;
  const selectionStart = bodyInput.selectionStart;
  const selectionEnd = bodyInput.selectionEnd;

  // console.log(bodyInput,selectionStart,selectionEnd);
  //if (!bodyInput || !selectionStart || !selectionEnd) return;
  const newContent = [
    bodyInput.value?.substring(0, selectionStart),
    emoji.native,
    bodyInput.value?.substring(selectionEnd),
  ].join('');

  // console.log(newContent,emoji.native);
  if (!newContent) return;

  bodyInput.value = newContent;
  handle_content(newContent)
  bodyInput.setSelectionRange(selectionStart + emoji.length, selectionStart + emoji.length);
  setEmoji(false);
  bodyInput.focus();
  bodyInput.selectionStart = bodyInput.value.length; 
};

const [isCopied, setIsCopied] = useState(false);
const [state, setState] = React.useState({
  openBar: true,
  vertical: 'bottom',
  horizontal: 'left',
});


const { vertical, horizontal, openBar } = state;

const handleClose = () => {
  setState({ ...state, openBar: false });
};


//console.log(replayinggMessageContent);
  return (
    <motion.div 
    transition={{ duration: 0.4 }}
     className={`eachChat ${matches&&"eachChatMinimized"}`}>
       {isCopied&&
        <Box sx={{ width: 300 }}>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={openBar}
            onClose={handleClose}
            message="Text copied"
            key={vertical + horizontal}
          />
      </Box>}

       {selected_chat_error?
          <div className="eachChat-notFound">
              Chat Not Found
          </div>
       :
       <>
            <div className={`eachChat-header`}>
                {selected_chat_load?
                  <div style={{display:"flex",alignItems:"center",gap:"20px"}}>
                     <div><Skeleton variant="circular" width={40} height={40} /></div>
                     <div>  <Skeleton animation="wave" height={30} width="50px" /></div>
                 </div>
               : 
                 <>
                    <div style={{display:"flex",justifyContent:"flex-start",alignItems:"center",gap:"5px"}}>
                      {matches&&<div  className={`chat-change-button`}><IconButton onClick={handleBackToAllChats}><ArrowBackIcon/></IconButton></div>}
                      <Link to={`/shop/${selected_chat_shop?._id}`} style={{color:"inherit",textDecoration:"none"}}>

                          <div className="eachChat-header-left">
                                <div><img width={50} height={50}  src={selected_chat_shop?.coverPic?.fileUrl||"/default-JB-FE-Shop_10.png"} alt='shope.pic'/></div>
                                <div>
                                    <div>{selected_chat_shop?.shope_name||"Deleted Shop"}</div>
                                    <div  className="eachChat-header-left-typing-status">{istyping&&<div>...typing</div>}</div>
                                </div>

                          </div>
                          
                        </Link>
                      
                    </div>
                    <div className="eachChat-header-right">
                          <IconButton><MoreVertIcon/></IconButton>
                      </div>
                 </>
                }
                
            </div>
         
          <div  ref={containerRef} className={`eachChat-allMessages`}>
              {AllChats?.map((e,index)=>{
                if(e?.deletedFrom?.includes(ActiveShope)){
                  return
                 }
                return <EachMessaages handleLatestMessage={handleLatestMessage} latestMessage={latestMessage} setState={setState} setIsCopied={setIsCopied} replayinggMessageContent={replayinggMessageContent} setReplayinggMessageContent={setReplayinggMessageContent} unread={unread} handleOnline={handleOnline} online={online} AllChats={AllChats} GetAllChats={GetAllChats}data={e} ActiveShope={ActiveShope} userData={userData} key={index}/>
              })}
          </div>
          
          <form enctype="multipart/form-data" className={`eachChat-input`}>
             {load_send?
               <div style={{textAlign:"center",fontWeight:"400",width:"100%",padding:"10px 0 10px 0"}}>... sending</div>
               :
               <>
                    {recordingStatus==="recording" ?
                      <>
                          <motion.form  enctype="multipart/form-data" 
                          initial={{opacity:0,x:-100}}
                          animate={{opacity:1,x:0}}
                          transition={{ duration: 0.4 }}
                          className={`eachChat-input-recording`}>
                          
                            <div className={`eachChat-input-recording-duration`}>
                                  <div><RadioButtonCheckedIcon style={{color:"red"}}/></div>
                                  <div>{duration&&formatTime(duration)}</div>
                            </div>
                            <div className={`eachChat-input-recording-cancel`}><IconButton onClick={stopRecording} ><DeleteIcon/></IconButton></div>
                            <div className={`eachChat-input-recording-send`}><IconButton onClick={sendAudioFile}><SendIcon/></IconButton></div>
                          </motion.form>
                        
                      </>
                    : 
                    <>
                       
                         <IconButton onClick={handleEmojiClick}>
                              <EmojiEmotionsIcon style={{ color: 'rgb(184, 122, 8)' }} />
                            </IconButton>
                         
                         <div style={{width:"100%"}}>
                              {replayinggMessageContent?._id&&
                                <motion.div
                                initial={{opacity:0,y:-50}}
                                animate={{opacity:1,y:0}}
                                transition={{ duration: 0.4 }}
                                className={`eachChat-input-replied`}>
                                    <section style={{textAlign:"end"}}><IconButton onClick={()=>setReplayinggMessageContent({})}><CloseIcon style={{fontSize:"12px"}}/></IconButton></section>
                                    <section className={`eachChat-input-replied-text-by`}>
                                      <div className={`eachChat-input-replied-by`}>{replayinggMessageContent?.sender?.shope_name}</div>
                                      <div className={`eachChat-input-replied-text`}>{replayinggMessageContent?.content?.length>50?`${replayinggMessageContent?.content.slice(0,50)}...`:replayinggMessageContent?.content}</div>
                                      <div className={`eachChat-input-replied-text`}>{replayinggMessageContent?.audio&&"Audio File"}</div>
                                      <div className={`eachChat-input-replied-text`}>{replayinggMessageContent?.image&&"Image File"}</div>
                                    </section>
                                  </motion.div>
                                
                                }

                              <textArea 
                                  style={{color:error_send&&"red"}}
                                  ref={myref}
                                  onKeyDown={handleKeyDown}
                                  autoFocus={true}
                                  autoSize={{
                                        minRows:1,
                                        maxRows: 2,
                                      }} 
                                  placeholder='message' value={content} onChange={typingHandler}/>
                              
                          </div>
                          
                          <div  className={`eachChat-input-send`} ><Button disabled={!content||error_send} onClick={Send_Message}>Send</Button></div>
                          <div><IconButton onClick={startRecording}><MicIcon /></IconButton></div>
                          <div>
                              <label>
                                  <input  type='file' onChange={handleImageChange} />
                                  <div><AttachFileIcon/></div>

                              </label>
                          </div>
                         
                            {emoji && (
                              <div  className={`eachChat-input-emoji-picker`}><Picker data={data} onEmojiSelect={handleEmojiSelect} /></div>
                            )}
                                              
                       </>
                      }
               </>
            }
          </form>

          {(selectedFile&&imageOptioned) && 
               <form enctype="multipart/form-data" className={`eachChat-input-images`}>
                  <div className='eachChat-input-images-box'>
                      {selectedFile?.type?.startsWith('image') && (
                        <img src={URL.createObjectURL(selectedFile)} alt="Uploaded" width={100}  />
                        ) }  
                        <div className={`eachChat-input-images-buttons`}>
                            <div><Button onClick={sendImage}>Send</Button></div>
                            <div><Button onClick={cancelImage}>Cancel</Button></div>
                        </div>     

                  </div>
               </form>
            }
       </>
   
        }
    </motion.div>
  )
}



